import { Tooltip } from 'primereact/tooltip';

export { Tooltip };
